"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5626],{

/***/ 83898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ KebabMenu; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48294);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91864);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76366);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81946);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin: 0;\n  top: -",
        "px;\n  right: -",
        "px;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ACTION_SHEET_MODAL_PREFIX = "__action-sheet";
var ActionSheet = function(param) {
    var name = param.name, options = param.options, children = param.children, onSelect = param.onSelect;
    var ref = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_6__/* .useWebView */ .B9)(), web = ref.web, listen = ref.listen;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().platform;
    var actionSheetName = "".concat(ACTION_SHEET_MODAL_PREFIX, "-").concat(name);
    var ref1 = _slicedToArray((0,_hooks_useModal__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)(actionSheetName, {
        routeChange: false,
        trigger: false
    }), 2), open = ref1[1].open;
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.stopPropagation();
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_4__/* .Platform.web */ .t4.web) {
            open(options);
        } else {
            web.openActionSheet(actionSheetName, options);
        }
    }, [
        platform,
        actionSheetName,
        options
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var unlisten = listen("actionSheetSelect", function(e) {
            var _detail = e.detail, name = _detail.name, index = _detail.value;
            if (name !== actionSheetName) {
                return;
            }
            var value = options[index] ? options[index].value : undefined;
            if (value) {
                onSelect(value);
            }
        });
        return unlisten;
    }, [
        options,
        onSelect
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
        children: children === null || children === void 0 ? void 0 : children(handleClick)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActionSheet);
/**
 * 케밥 형태
 */ var kebabMenuCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium);
var KebabMenu = function(_param) {
    var className = _param.className, props = _objectWithoutProperties(_param, [
        "className"
    ]);
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ActionSheet, _objectSpreadProps(_objectSpread({}, props), {
        children: function(open) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("aside", {
                className: className,
                css: kebabMenuCSS,
                onClick: open,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .VerticalEllipsis */ .oR,
                    color: theme.var.gray500,
                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small
                })
            });
        }
    }));
};


/***/ }),

/***/ 95728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11717);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
// SwipeableListContainer.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var listContainerCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject());
var SwipeableListContainer = function(param) {
    var children = param.children, className = param.className;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isDragging = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var startX = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    var scrollLeft = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var el = containerRef.current;
        if (!el) return;
        var handleMouseDown = function(e) {
            isDragging.current = true;
            startX.current = e.pageX - el.offsetLeft;
            scrollLeft.current = el.scrollLeft;
            el.style.cursor = "grabbing";
        };
        var handleMouseMove = function(e) {
            if (!isDragging.current) return;
            e.preventDefault();
            var x = e.pageX - el.offsetLeft;
            var walk = (x - startX.current) * 1.2;
            el.scrollLeft = scrollLeft.current - walk;
        };
        var handleMouseUp = function() {
            isDragging.current = false;
            el.style.cursor = "grab";
        };
        el.addEventListener("mousedown", handleMouseDown);
        el.addEventListener("mousemove", handleMouseMove);
        el.addEventListener("mouseleave", handleMouseUp);
        el.addEventListener("mouseup", handleMouseUp);
        return function() {
            el.removeEventListener("mousedown", handleMouseDown);
            el.removeEventListener("mousemove", handleMouseMove);
            el.removeEventListener("mouseleave", handleMouseUp);
            el.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        css: listContainerCSS,
        className: className,
        ref: containerRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwipeableListContainer);


/***/ }),

/***/ 54581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PlayListLoading": function() { return /* binding */ PlayListLoading; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ play; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(8683);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(11717);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-7a26ef4a22/0/cache/@emotion-react-npm-11.11.1-a07d6a6ebd-aec3c36650.zip/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.js + 2 modules
var emotion_element_c39617d8_browser_esm = __webpack_require__(71618);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-i18next-virtual-9e5d267e7d/0/cache/next-i18next-npm-12.1.0-68b3291791-8c0e2f9764.zip/node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./.yarn/__virtual__/next-virtual-9251101693/0/cache/next-npm-12.3.4-cdaf2db0a7-d96fc4f5bc.zip/node_modules/next/router.js
var next_router = __webpack_require__(47311);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(39953);
// EXTERNAL MODULE: ./.yarn/__virtual__/react-query-virtual-8f3bd3534b/0/cache/react-query-npm-3.39.3-72b2a93edf-d2de6a0992.zip/node_modules/react-query/es/index.js
var es = __webpack_require__(54909);
// EXTERNAL MODULE: ./hooks/query/useOutlook.ts
var useOutlook = __webpack_require__(48049);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/index.js + 10 modules
var dist_esm = __webpack_require__(91864);
;// CONCATENATED MODULE: ./components/characters/FloatingCreateButton.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  bottom: ",
        "px;\n  right: ",
        "px;\n  width: 64px;\n  height: 64px;\n  border-radius: ",
        "px;\n  z-index: 100;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);\n  background: linear-gradient(34.71deg, #20a2ae 3.8%, #5563e1 84.21%);\n\n  ",
        ";\n  font-size: 12px;\n  text-align: center;\n  line-height: 16.2px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var floatingButtonCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(_templateObject(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Radius.round */.wU.round, dist_esm/* Typography.h6 */.ZT.h6, theme.var.white);
};
var FloatingCreateButton = function(param) {
    var handleOnClick = param.handleOnClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: floatingButtonCSS,
        className: "floating-create",
        onClick: handleOnClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("p", {
            children: [
                "캐릭터",
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("br", {}),
                "만들기"
            ]
        })
    });
};
/* harmony default export */ var characters_FloatingCreateButton = (FloatingCreateButton);

;// CONCATENATED MODULE: ./components/common/FloatingButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FloatingButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FloatingButton_templateObject() {
    var data = FloatingButton_taggedTemplateLiteral([
        "\n  position: fixed;\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n  align-items: center;\n  width: ",
        "px;\n  height: ",
        "px;\n  top: ",
        "px;\n  left: ",
        "px;\n  right: ",
        "px;\n  bottom: ",
        "px;\n  border-radius: ",
        "px;\n  z-index: 98;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.4);\n  background: ",
        ";\n"
    ]);
    FloatingButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var buttonCSS = function(param) {
    var _width = param.width, width = _width === void 0 ? 64 : _width, _height = param.height, height = _height === void 0 ? 64 : _height, top = param.top, left = param.left, _right = param.right, right = _right === void 0 ? dist_esm/* Spacing.medium */.Ki.medium : _right, _bottom = param.bottom, bottom = _bottom === void 0 ? dist_esm/* Spacing.medium */.Ki.medium : _bottom, _borderRadius = param.borderRadius, borderRadius = _borderRadius === void 0 ? dist_esm/* Radius.round */.wU.round : _borderRadius, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "linear-gradient(34.71deg, #20a2ae 3.8%, #5563e1 84.21%)" : _backgroundColor, padding = param.padding;
    return (0,emotion_react_browser_esm.css)(FloatingButton_templateObject(), padding, width, height, top, left, right, bottom, borderRadius, backgroundColor);
};
var FloatingButton = function(props) {
    var onClick = props.onClick, children = props.children, className = props.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
        css: buttonCSS(_objectSpread({}, props)),
        onClick: onClick,
        className: className,
        children: children
    });
};
/* harmony default export */ var common_FloatingButton = (FloatingButton);

// EXTERNAL MODULE: ./components/common/HomeHeader.tsx + 7 modules
var HomeHeader = __webpack_require__(86436);
// EXTERNAL MODULE: ./components/common/Pagination.tsx
var Pagination = __webpack_require__(39753);
// EXTERNAL MODULE: ./components/common/Tab.tsx
var Tab = __webpack_require__(93127);
// EXTERNAL MODULE: ./components/home/HomeHeaderContainer.tsx
var HomeHeaderContainer = __webpack_require__(66806);
// EXTERNAL MODULE: ./components/layout/Layout.tsx
var Layout = __webpack_require__(26382);
// EXTERNAL MODULE: ./components/layout/Push.tsx
var Push = __webpack_require__(23516);
// EXTERNAL MODULE: ./components/layout/SafeArea.tsx
var SafeArea = __webpack_require__(45861);
// EXTERNAL MODULE: ./hooks/useCharacterPost.ts
var useCharacterPost = __webpack_require__(38283);
// EXTERNAL MODULE: ./.yarn/cache/camelize-npm-1.0.1-d86ebe085a-91d8611d09.zip/node_modules/camelize/index.js
var camelize = __webpack_require__(94100);
var camelize_default = /*#__PURE__*/__webpack_require__.n(camelize);
// EXTERNAL MODULE: ./components/common/Button.tsx
var Button = __webpack_require__(38945);
// EXTERNAL MODULE: ./components/common/Empty.tsx
var Empty = __webpack_require__(34270);
// EXTERNAL MODULE: ./components/community/CharacterPost.tsx
var CharacterPost = __webpack_require__(1289);
// EXTERNAL MODULE: ./components/layout/Pad.tsx
var Pad = __webpack_require__(95833);
// EXTERNAL MODULE: ./components/modal/ImageModal.tsx
var ImageModal = __webpack_require__(11502);
// EXTERNAL MODULE: ./api/feed.ts
var feed = __webpack_require__(83955);
// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(39854);
// EXTERNAL MODULE: ./contexts/global.ts
var global = __webpack_require__(30259);
// EXTERNAL MODULE: ./utils/query.ts
var utils_query = __webpack_require__(96261);
// EXTERNAL MODULE: ./utils/webview.ts
var webview = __webpack_require__(81946);
;// CONCATENATED MODULE: ./components/outlook/HomeGround.tsx
function HomeGround_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HomeGround_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HomeGround_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function HomeGround_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HomeGround_templateObject() {
    var data = HomeGround_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 42px;\n\n  .chat-enter-pad {\n    padding: ",
        "px ",
        "px;\n  }\n\n  .empty-btn {\n    width: 196px;\n    height: 48px;\n    margin-top: 20px;\n  }\n"
    ]);
    HomeGround_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var groundContainerCSS = (0,emotion_react_browser_esm.css)(HomeGround_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var HomeGroundDetail = function(param) {
    var activeTabInTab = param.activeTabInTab, chips = param.chips, handleActionSheet = param.handleActionSheet, likePost = param.likePost, handleNavigatePostDetail = param.handleNavigatePostDetail, handleClickTag = param.handleClickTag, handleClickImg = param.handleClickImg;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var web = (0,webview/* useWebView */.B9)().web;
    var selectedChip = chips === null || chips === void 0 ? void 0 : chips.find(function(chip) {
        return chip.label === activeTabInTab;
    });
    var query = selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.value;
    var feedQuery = (0,utils_query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.OUT_LOOK.GROUND_FEED */.U7.OUT_LOOK.GROUND_FEED(activeTabInTab, query), function(param) {
        var pageParam = param.pageParam;
        return (0,feed/* fetchHomeFeeds */.g)(selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key, query, pageParam);
    }, {
        enabled: !!selectedChip,
        suspense: false
    });
    var handleClickGroundCharacter = function(characterId) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(characterId, "?tab=community"));
        } else {
            web.openPage("/play/characters/".concat(characterId, "?tab=community"));
        }
    };
    var handleClickEmpty = function() {
        if ((selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key) === "my_character") {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push("/studio?tab=play");
            } else {
                web.openPage("/studio?tab=play");
            }
        } else {
            if (platform === constants/* Platform.web */.t4.web) {
                router.push("/play/situations/0/chat-room");
            } else {
                web.openPage("/play/situations/0/chat-room");
            }
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                    name: "user-post-list",
                    query: feedQuery,
                    border: true,
                    children: function(item) {
                        var ref, ref1, ref2, ref3, ref4;
                        if (!item.post) {
                            return;
                        }
                        var playerId = (ref = item.character) === null || ref === void 0 ? void 0 : (ref1 = ref.player) === null || ref1 === void 0 ? void 0 : ref1.user_id;
                        var characterId = item.character.id;
                        var postId = (ref2 = item.post) === null || ref2 === void 0 ? void 0 : ref2.id;
                        var character = item.character;
                        var handleClickActionSheet = function(value, id) {
                            handleActionSheet(value, id, playerId, characterId);
                        };
                        var handleClickPlay = function(character) {
                            var characterId = character.id;
                            handleClickGroundCharacter(characterId);
                        };
                        var handleClickLike = function(post) {
                            likePost(post, characterId, query);
                        };
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pad/* default */.Z, {
                            onClick: function() {
                                return handleNavigatePostDetail(characterId, postId, playerId);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(CharacterPost/* default */.Z, _objectSpreadProps(HomeGround_objectSpread({
                                onLike: handleClickLike,
                                프: true,
                                playerId: playerId,
                                showFixedIcon: false,
                                handleClickPlay: handleClickPlay,
                                playButton: true,
                                handleClickImg: handleClickImg,
                                hasFixedAction: false,
                                imageHeight: 400,
                                character: character,
                                tags: item === null || item === void 0 ? void 0 : (ref3 = item.character) === null || ref3 === void 0 ? void 0 : ref3.tags
                            }, camelize_default()(item.post)), {
                                clip: true,
                                handleActionSheet: handleClickActionSheet,
                                handleClickTag: handleClickTag,
                                commentPreview: (ref4 = item.post) === null || ref4 === void 0 ? void 0 : ref4.previewComments
                            }))
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Empty/* default */.Z, {
                query: feedQuery,
                children: [
                    (selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key) !== "my_character" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("아직 플레이한 캐릭터가 없네요.")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("얼른 시작해볼까요?")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                onClick: handleClickEmpty,
                                type: "border",
                                text: t("내 취향 찾으러 가기  \uD83D\uDD0D"),
                                className: "empty-btn"
                            })
                        ]
                    }),
                    (selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key) === "my_character" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("캐릭터를 만들거나")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                children: t("내 캐릭터에 그라운드 글을 작성해 보세요!")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                                onClick: handleClickEmpty,
                                type: "border",
                                text: t("내 플레이로 갈래요 \uD83D\uDC40"),
                                className: "empty-btn"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var HomeGround = function(param) {
    var chips = param.chips;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var tabInTabs = chips.map(function(chip) {
        return {
            label: t(chip.key),
            value: t(chip.label)
        };
    });
    var queryClient = (0,es.useQueryClient)();
    var ref1 = (0,react.useState)((ref = tabInTabs[0]) === null || ref === void 0 ? void 0 : ref.value), activeTabInTab = ref1[0], setActiveTabInTab = ref1[1];
    var handleChangeTab = function(tab) {
        if (tab !== activeTabInTab) {
            setActiveTabInTab(tab);
        } else {
            queryClient.refetchQueries(constants/* QUERY_KEYS.OUT_LOOK.GROUND_FEED_ALL */.U7.OUT_LOOK.GROUND_FEED_ALL);
        }
    };
    var tabInTabsInstance = {
        tabs: tabInTabs,
        activeTab: activeTabInTab,
        onChange: handleChangeTab
    };
    var ref2 = (0,useCharacterPost/* useCharacterPost */.x)(activeTabInTab), handleActionSheet = ref2.handleActionSheet, likePost = ref2.likePost, handleNavigatePostDetail = ref2.handleNavigatePostDetail, handleClickTag = ref2.handleClickTag, handleClickImg = ref2.handleClickImg, closeImageModal = ref2.closeImageModal, isImageModalOpen = ref2.isImageModalOpen, selectedImage = ref2.selectedImage;
    (0,react.useEffect)(function() {
        if (chips && chips.length > 0) {
            setActiveTabInTab(chips[0].label);
        }
    }, [
        chips
    ]);
    if (!chips || chips.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PlayListLoading, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                css: groundContainerCSS,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, _objectSpreadProps(HomeGround_objectSpread({}, tabInTabsInstance), {
                        type: "badge",
                        hideBorder: true
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeGroundDetail, {
                        chips: chips,
                        activeTabInTab: activeTabInTab,
                        handleActionSheet: handleActionSheet,
                        likePost: likePost,
                        handleNavigatePostDetail: handleNavigatePostDetail,
                        handleClickTag: handleClickTag,
                        handleClickImg: handleClickImg
                    })
                ]
            }),
            selectedImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ImageModal/* default */.Z, {
                open: isImageModalOpen,
                image: selectedImage,
                onClose: closeImageModal
            })
        ]
    });
};
/* harmony default export */ var outlook_HomeGround = (HomeGround);

// EXTERNAL MODULE: ./hooks/useModal.ts
var useModal = __webpack_require__(48294);
// EXTERNAL MODULE: ./components/chat/PeekRoomCard.tsx
var PeekRoomCard = __webpack_require__(77426);
// EXTERNAL MODULE: ./.yarn/__virtual__/chatie-design-system-virtual-b8844a88ad/0/cache/chatie-design-system-https-b493a1675a-e8ede12d88.zip/node_modules/chatie-design-system/dist/esm/components/icon/index.js
var icon = __webpack_require__(76366);
// EXTERNAL MODULE: ./components/common/Image.tsx
var Image = __webpack_require__(85496);
// EXTERNAL MODULE: ./components/common/Overlay.tsx + 1 modules
var Overlay = __webpack_require__(90814);
;// CONCATENATED MODULE: ./public/images/peek/peek_banner.png
/* harmony default export */ var peek_banner = ({"src":"https://mn.chatie.me/assets/9c47eb6c757efc44885ea14ce12be40135366831/_next/static/media/peek_banner.916d906d.png","height":58,"width":522,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEW4vL3CwsJ3XA/7AAAAAnRSTlPLzMxPTSYAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAANSURBVAiZY2BkZAADAAAYAAOp1X5mAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./components/common/Modal.tsx
var Modal = __webpack_require__(59585);
;// CONCATENATED MODULE: ./components/modal/PeekBannerModal.tsx
function PeekBannerModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function PeekBannerModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PeekBannerModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PeekBannerModal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function PeekBannerModal_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        PeekBannerModal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function PeekBannerModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PeekBannerModal_templateObject() {
    var data = PeekBannerModal_taggedTemplateLiteral([
        "\n  overflow: scroll;\n  z-index: 999;\n  .pink {\n    background: var(\n      --_pink,\n      linear-gradient(55deg, #ff07f5 20.46%, #ed0064 82.76%)\n    );\n    -webkit-background-clip: text;\n    background-clip: text;\n    color: transparent;\n    display: inline;\n  }\n  .title {\n    ",
        ";\n    text-align: center;\n    line-height: 18px;\n    font-weight: 700;\n    margin-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n  .close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n  }\n  input {\n    max-width: 90%;\n  }\n  ul {\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        "px;\n    margin: ",
        "px 0;\n    gap: ",
        "px;\n  }\n  ul > li {\n    word-break: break-all;\n    ",
        ";\n    font-size: 14px;\n    list-style-type: disc;\n    color: ",
        ";\n    line-height: 18.9px;\n  }\n  .guide-container {\n    align-self: center;\n  }\n"
    ]);
    PeekBannerModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = PeekBannerModal_taggedTemplateLiteral([
        "\n        transform: scale(1);\n        visibility: visible;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = PeekBannerModal_taggedTemplateLiteral([
        "\n        transition: 0.25s;\n        transform: scale(0.4);\n        opacity: 0;\n        visibility: hidden;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = PeekBannerModal_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var containerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(PeekBannerModal_templateObject(), dist_esm/* Typography.h4 */.ZT.h4, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.xhsmall */.Ki.xhsmall, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.xlarge */.Ki.xlarge, dist_esm/* Spacing.xsmall */.Ki.xsmall, dist_esm/* Typography.body14 */.ZT.body14, theme.var.gray900);
};
var overlayCSS = function(isOpen) {
    return (0,emotion_react_browser_esm.css)(_templateObject3(), dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Spacing.medium */.Ki.medium, isOpen ? (0,emotion_react_browser_esm.css)(_templateObject1()) : (0,emotion_react_browser_esm.css)(_templateObject2()));
};
var PeekBannerModal = function(_param) {
    var props = _extends({}, _param);
    var t = (0,esm/* useTranslation */.$G)().t;
    var onClose = props.onClose, open = props.open;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Overlay/* default */.Z, PeekBannerModal_objectSpreadProps(PeekBannerModal_objectSpread({}, props), {
        blocking: false,
        css: overlayCSS(open),
        onClosePageClick: onClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
            css: (0,Modal/* modalCSS */.WB)(open),
            className: "modal-container",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: Modal/* contentCSS */.b$,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    css: containerCSS,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "close",
                            onClick: function() {
                                return props.onClose();
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icon/* Icon */.JO, {
                                icon: icon/* Close */.x8
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                            className: "title",
                            children: t("엿보기 알아보기  \uD83D\uDC40")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("li", {
                                    children: t("대화방 오른쪽 상단 엿보기 버튼을 활성화하면 나의 재미있는 대화방이 공개돼요!")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                    className: "guide-container",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Image/* default */.Z, {
                                        src: peek_banner,
                                        alt: t("엿보기 가이드 이미지"),
                                        height: 29,
                                        width: 261
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("li", {
                                    children: t("나의 대화도 공개하고 다른 채티즈의 대화를 탭하며 엿보기 해보세요!")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Modal/* ModalButton */.mH, {
                            text: t("확인했어요"),
                            onClick: function() {
                                return onClose();
                            }
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var modal_PeekBannerModal = (PeekBannerModal);

// EXTERNAL MODULE: ./api/chatbot.ts
var chatbot = __webpack_require__(23082);
// EXTERNAL MODULE: ./api/user.ts
var user = __webpack_require__(9622);
// EXTERNAL MODULE: ./components/outlook/OutlookComponent.tsx + 14 modules
var OutlookComponent = __webpack_require__(3455);
;// CONCATENATED MODULE: ./components/outlook/HomePeek.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function HomePeek_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function HomePeek_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HomePeek_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HomePeek_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HomePeek_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HomePeek_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function HomePeek_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function HomePeek_templateObject() {
    var data = HomePeek_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: 42px;\n\n  .tabInTab {\n    padding: 16px 12px 20px 12px;\n  }\n\n  .chat-enter-pad {\n    padding: ",
        "px ",
        "px;\n  }\n\n  .empty-btn {\n    width: 196px;\n    height: 48px;\n    margin-top: 20px;\n  }\n\n  .outlook-container {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n"
    ]);
    HomePeek_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HomePeek_templateObject1() {
    var data = HomePeek_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  background: ",
        ";\n  padding: 10px ",
        "px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n\n  p {\n    ",
        ";\n  }\n"
    ]);
    HomePeek_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}























var HomePeek_groundContainerCSS = (0,emotion_react_browser_esm.css)(HomePeek_templateObject(), dist_esm/* Spacing.small */.Ki.small, dist_esm/* Spacing.medium */.Ki.medium);
var peekBannerCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(HomePeek_templateObject1(), theme.colors.main50, dist_esm/* Spacing.medium */.Ki.medium, dist_esm/* Typography.body12 */.ZT.body12);
};
var HomePeekDetail = function(param) {
    var activeTabInTab = param.activeTabInTab, chips = param.chips;
    var ref;
    var platform = (0,global/* useGlobalContext */.bN)().platform;
    var t = (0,esm/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var web = (0,webview/* useWebView */.B9)().web;
    var peekBannerModalName = "peek-banner-modal";
    var ref1 = _slicedToArray((0,useModal/* useModal */.d)(peekBannerModalName), 2), isPeekBannerModalOpen = ref1[0], ref2 = ref1[1], openPeekBannerModal = ref2.open, closePeekBannerModal = ref2.close;
    var selectedChip = chips === null || chips === void 0 ? void 0 : chips.find(function(chip) {
        return chip.label === activeTabInTab;
    });
    var tabQuery = HomePeek_defineProperty({}, selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key, selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.value);
    var query = (0,utils_query/* useChatPaginationQuery */.aI)(constants/* QUERY_KEYS.PEEK.OUTLOOK_CODE */.U7.PEEK.OUTLOOK_CODE(activeTabInTab, selectedChip === null || selectedChip === void 0 ? void 0 : selectedChip.key), function(param) {
        var pageParam = param.pageParam;
        return (0,chatbot/* fetchPeekRooms */.Fp)(tabQuery, pageParam);
    }, {
        enabled: !!selectedChip,
        suspense: false
    });
    var ref3 = (0,react.useState)(-1), currentPage = ref3[0], setCurrentPage = ref3[1];
    var dataList = query === null || query === void 0 ? void 0 : (ref = query.data) === null || ref === void 0 ? void 0 : ref.pages.map(function(v) {
        return v.items;
    });
    var userIdList = (0,react.useMemo)(function() {
        return currentPage >= 0 && _toConsumableArray(new Set(dataList && dataList[currentPage].filter(function(v) {
            return !v.peek.is_anonymous;
        }).map(function(v) {
            return v.user_id;
        }))) || [];
    }, [
        currentPage
    ]);
    var ref4 = (0,react.useState)([]), totalUserList = ref4[0], setTotalUserList = ref4[1];
    var ref5 = (0,es.useQuery)(constants/* QUERY_KEYS.USER.LIST */.U7.USER.LIST(userIdList), function() {
        return (0,user/* fetchUserList */.ET)(userIdList);
    }, {
        enabled: currentPage >= 0
    }), userList = ref5.data;
    var setUserList = (0,react.useCallback)(/*#__PURE__*/ _asyncToGenerator(function() {
        var list;
        return __generator(this, function(_state) {
            if (userList) {
                list = _toConsumableArray(totalUserList);
                list.push(userList);
                setTotalUserList(list);
            }
            return [
                2
            ];
        });
    }), [
        userList
    ]);
    (0,react.useEffect)(function() {
        if (userList) {
            setUserList();
        }
    }, [
        setUserList
    ]);
    var handleClickEmpty = function() {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/library?tab=chat-library");
        } else {
            web.openPage("/library?tab=chat-library");
        }
    };
    var handleClickBanner = function() {
        openPeekBannerModal();
    };
    var handleClickCard = function(id) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/chat-rooms/".concat(id, "/peek"));
        } else {
            web.openPage("/play/chat-rooms/".concat(id, "/peek"));
        }
    };
    var handleClickProfile = function(e, id) {
        e.stopPropagation();
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/".concat(id));
        } else {
            web.openPage("/play/characters/".concat(id));
        }
    };
    if (!chips || chips.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PlayListLoading, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: peekBannerCSS,
                onClick: handleClickBanner,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                    children: t("엿보기가 뭔지 궁금하다면? 여기를 눌러봐요 >")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                    name: "peek-room-tab-list",
                    query: query,
                    border: true,
                    children: function(item, i, pageIndex) {
                        var ref;
                        pageIndex > currentPage && setCurrentPage(pageIndex);
                        var user = pageIndex >= 0 && (totalUserList === null || totalUserList === void 0 ? void 0 : totalUserList.length) && ((ref = totalUserList[pageIndex]) === null || ref === void 0 ? void 0 : ref.find(function(user) {
                            return user.id === item.user_id;
                        })) || undefined;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PeekRoomCard/* default */.Z, {
                            user: user,
                            peekInfo: item,
                            onClickProfile: handleClickProfile,
                            onClickCard: handleClickCard
                        }, i);
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Empty/* default */.Z, {
                query: query,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            children: t("캐릭터의 엿보기가 아직 없어요")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                            children: t("내가 나눈 대화로 엿보기를 on 해보세요!")
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                            onClick: handleClickEmpty,
                            type: "border",
                            text: t("보관함 내 플레이로 갈래요 \uD83D\uDC40"),
                            className: "empty-btn"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(modal_PeekBannerModal, {
                name: peekBannerModalName,
                open: isPeekBannerModalOpen,
                onClose: closePeekBannerModal
            })
        ]
    });
};
var HomePeek = function(param) {
    var chips = param.chips;
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var tabInTabs = chips.map(function(chip) {
        return {
            label: t(chip.key),
            value: t(chip.label)
        };
    });
    var ref1 = (0,react.useState)((ref = tabInTabs[0]) === null || ref === void 0 ? void 0 : ref.value), activeTabInTab = ref1[0], setActiveTabInTab = ref1[1];
    var outlookTab = chips.filter(function(item) {
        return item.value === "outlook";
    });
    var isOutlookTab = outlookTab.find(function(item) {
        return item.label === activeTabInTab;
    });
    var outlookKey = (isOutlookTab === null || isOutlookTab === void 0 ? void 0 : isOutlookTab.key) || "";
    var handleChangeTab = function(tab) {
        if (tab !== activeTabInTab) {
            setActiveTabInTab(tab);
        }
    };
    var tabInTabsInstance = {
        tabs: tabInTabs,
        activeTab: activeTabInTab,
        onChange: handleChangeTab
    };
    var usePageOutlook = (0,useOutlook/* useOutlook */.p)().usePageOutlook;
    var outlook = usePageOutlook(outlookKey, {
        enabled: !!isOutlookTab
    }, 5);
    (0,react.useEffect)(function() {
        if (chips && chips.length > 0) {
            setActiveTabInTab(chips[0].label);
        }
    }, [
        chips
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
            css: HomePeek_groundContainerCSS,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Tab/* default */.Z, HomePeek_objectSpreadProps(HomePeek_objectSpread({
                    className: "tabInTab"
                }, tabInTabsInstance), {
                    type: "badge",
                    hideBorder: true
                })),
                !!isOutlookTab ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                    name: "play-outlook-home-peek-all-list",
                    query: outlook,
                    className: "outlook-container",
                    identifier: "key",
                    children: function(item, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(OutlookComponent/* default */.Z, {
                            component: item,
                            order: index
                        }, index);
                    }
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomePeekDetail, {
                    chips: chips,
                    activeTabInTab: activeTabInTab
                })
            ]
        })
    });
};
/* harmony default export */ var outlook_HomePeek = (HomePeek);

// EXTERNAL MODULE: ./components/skeleton/Frame.tsx
var Frame = __webpack_require__(19827);
// EXTERNAL MODULE: ./components/skeleton/PlaySkeleton.tsx
var PlaySkeleton = __webpack_require__(4223);
// EXTERNAL MODULE: ./components/skeleton/SkeletonList.tsx
var SkeletonList = __webpack_require__(6668);
// EXTERNAL MODULE: ./api/event.ts
var api_event = __webpack_require__(64143);
// EXTERNAL MODULE: ./contexts/auth.tsx
var auth = __webpack_require__(71727);
// EXTERNAL MODULE: ./styles/css.tsx
var css = __webpack_require__(96964);
// EXTERNAL MODULE: ./utils/analytics.ts
var analytics = __webpack_require__(3263);
// EXTERNAL MODULE: ./utils/hook.ts
var hook = __webpack_require__(97033);
// EXTERNAL MODULE: ./utils/localStorage.ts
var localStorage = __webpack_require__(48163);
// EXTERNAL MODULE: ./utils/misc.ts + 1 modules
var misc = __webpack_require__(45874);
;// CONCATENATED MODULE: ./pages/play/index.tsx
function play_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function play_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                play_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                play_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function play_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var play_generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function play_templateObject() {
    var data = play_taggedTemplateLiteral([
        "\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        "px;\n    margin-top: ",
        ";\n  }\n"
    ]);
    play_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function play_templateObject1() {
    var data = play_taggedTemplateLiteral([
        "\n  max-width: 500px;\n  margin: 0 auto;\n  position: relative;\n\n  .floating-wrapper {\n    display: flex;\n    flex-direction: row-reverse;\n    gap: 16px;\n    width: 100%;\n    max-width: 500px;\n    padding: 16px;\n    position: fixed;\n    bottom: ",
        ";\n    z-index: 100;\n\n    .floating-promo {\n      position: static;\n      display: flex;\n      flex: 1;\n    }\n\n    .floating-create {\n      position: static;\n      display: flex;\n      align-self: flex-end;\n    }\n  }\n"
    ]);
    play_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function play_templateObject2() {
    var data = play_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n\n  .upper-container {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n\n    .title {\n      color: ",
        ";\n      ",
        ";\n    }\n    .timer {\n      display: inline-flex;\n      padding: 4px 6px;\n      border-radius: 10px;\n      height: 18px;\n      background: ",
        ";\n      color: ",
        ";\n      text-align: center;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 100%;\n    }\n  }\n  .under-container {\n    display: flex;\n    width: 100%;\n    gap: 6px;\n    align-items: center;\n    color: ",
        ";\n    ",
        "\n    margin-top:9px;\n\n    .timer {\n      display: flex;\n      padding: 4px 6px;\n      border-radius: 10px;\n      height: 18px;\n      background: ",
        ";\n      color: ",
        ";\n      text-align: center;\n      font-size: 10px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 100%;\n    }\n  }\n  .description {\n    color: rgba(255, 255, 255, 0.6);\n    margin-top: 10px;\n    ",
        "\n  }\n"
    ]);
    play_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function play_templateObject3() {
    var data = play_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    play_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = play_taggedTemplateLiteral([
        "\n  padding-bottom: 62.5%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


































var homeContainerCSS = function(isCheming) {
    return (0,emotion_react_browser_esm.css)(play_templateObject(), dist_esm/* Spacing.large */.Ki.large, isCheming ? "10px" : "42px");
};
var floatingButtonContainerCSS = function(isCheming) {
    return (0,emotion_react_browser_esm.css)(play_templateObject1(), isCheming ? "".concat(Push/* PushSize.bottomTab */.z.bottomTab, "px") : "0");
};
var promoCSS = function(theme) {
    return (0,emotion_react_browser_esm.css)(play_templateObject2(), theme.var.white, dist_esm/* Typography.h5 */.ZT.h5, theme.var.gray900, theme.var.white, theme.var.white, dist_esm/* Typography.body11 */.ZT.body11, theme.var.gray900, theme.var.white, dist_esm/* Typography.body11 */.ZT.body11);
};
var PlayDetail = function() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var theme = (0,emotion_element_c39617d8_browser_esm.u)();
    var router = (0,next_router.useRouter)();
    var shareUUID = router.query.share_uid;
    var web = (0,webview/* useWebView */.B9)().web;
    var ref = (0,global/* useGlobalContext */.bN)(), platform = ref.platform, isCheming = ref.isCheming;
    var firebase = (0,analytics/* useAnalytics */.z)().firebase;
    var ref1 = (0,hook/* useMe */.Pi)({
        suspense: false
    }), me = ref1.data, refetchMe = ref1.refetch;
    var ref2 = (0,hook/* useAdultCertifaction */.My)(), isAdult = ref2.data;
    var ref3 = (0,es.useMutation)(api_event/* postCaptureUUID */.vl), postUUID = ref3.mutate;
    var tabs = (0,Tab/* useTab */.x)(!isAdult ? [
        {
            label: t("플레이"),
            value: t("home")
        },
        {
            label: t("그라운드"),
            value: t("home_ground")
        }, 
    ] : [
        {
            label: t("플레이"),
            value: t("home")
        },
        {
            label: t("엿보기"),
            value: t("home_peek")
        },
        {
            label: t("그라운드"),
            value: t("home_ground")
        }, 
    ], {
        replace: true,
        withoutReRendering: true,
        refresh: false
    });
    var activeTab = tabs.activeTab, setLastPeekTabViewDate = tabs.setLastPeekTabViewDate, lastPeekTabViewDate = tabs.lastPeekTabViewDate;
    var myMessageToken = me === null || me === void 0 ? void 0 : me.chatToken;
    var usePageOutlook = (0,useOutlook/* useOutlook */.p)().usePageOutlook;
    var outlook = usePageOutlook(activeTab, {
        suspense: false
    }, 5);
    (0,hook/* useScreen */.EV)("플레이");
    var chips = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        return (outlook === null || outlook === void 0 ? void 0 : (ref = outlook.data) === null || ref === void 0 ? void 0 : ref.pages[0]) ? (ref4 = (ref2 = outlook === null || outlook === void 0 ? void 0 : (ref1 = outlook.data) === null || ref1 === void 0 ? void 0 : ref1.pages[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.items) === null || ref3 === void 0 ? void 0 : ref3.find(function(component) {
            return (component === null || component === void 0 ? void 0 : component.view_type) === "choice_chips";
        })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.choices : [];
    }, [
        outlook
    ]);
    // const [isAosPurchased, setIsAosPurchased] = useState(false);
    var ref4 = (0,react.useState)(0), promoWidth = ref4[0], setPromoWidth = ref4[1];
    // const isProduction = isEnv('production');
    // const isIos = platform === Platform.ios;
    // const subItemId = SUBSCRIBE_ITEM_ID(isProduction, isIos);
    // const passItemId = PASS_ITEM_ID(isProduction, isIos);
    // const isOverVersion = checkRequiredAppVersion(
    //   platform,
    //   version,
    //   SUBSCIRBE_VERSION
    // );
    var handleMoveCharacterDetail = function(id) {
        firebase.logEvent("chatbot_click_play_curation", {
            curation_view_type: "content_gallery_with_header"
        });
        if (platform === constants/* Platform.web */.t4.web && id) {
            router.push("/play/characters/".concat(id));
        } else {
            web.openPage("/play/characters/".concat(id));
        }
    };
    var onClickSituation = function() {
        var _ref = play_asyncToGenerator(function(e, content) {
            var id;
            return play_generator(this, function(_state) {
                e.preventDefault();
                firebase.logEvent("chatbot_click_play_curation", {
                    curation_view_type: "content_gallery_with_header"
                });
                if (!me) {
                    alert("로그인이 필요한 서비스입니다.");
                    if (platform === constants/* Platform.web */.t4.web) {
                        return [
                            2,
                            router.push("/signin")
                        ];
                    }
                    return [
                        2
                    ];
                }
                id = content.id;
                if (platform === constants/* Platform.web */.t4.web && id) {
                    return [
                        2,
                        router.push("/play/situations/".concat(id, "/chat-room"))
                    ];
                } else {
                    return [
                        2,
                        web.openPage("/play/situations/".concat(id, "/chat-room"))
                    ];
                }
                return [
                    2
                ];
            });
        });
        return function onClickSituation(e, content) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickSituationById = function() {
        var _ref = play_asyncToGenerator(function(situationId) {
            return play_generator(this, function(_state) {
                if (!me) {
                    alert("로그인이 필요한 서비스입니다.");
                    if (platform === constants/* Platform.web */.t4.web) {
                        return [
                            2,
                            router.push("/signin")
                        ];
                    }
                    return [
                        2
                    ];
                }
                setTimeout(function() {
                    if (platform === constants/* Platform.web */.t4.web && situationId) {
                        return router.push("/play/situations/".concat(situationId, "/chat-room"));
                    } else {
                        return web.openPage("/play/situations/".concat(situationId, "/chat-room"));
                    }
                }, 300);
                return [
                    2
                ];
            });
        });
        return function onClickSituationById(situationId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreateChatRoom = function() {
        var _ref = play_asyncToGenerator(function(id) {
            var ref, ref1, data;
            return play_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,chatbot/* fetchSituations */.XZ)({
                                character_id: id
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        if (data && (data === null || data === void 0 ? void 0 : (ref = data.items) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = data.items[0]) === null || ref1 === void 0 ? void 0 : ref1.id)) {
                            if (platform === constants/* Platform.web */.t4.web) {
                                router.push("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            } else {
                                web.openPage("/play/situations/".concat(data.items[0].id, "/chat-room"));
                            }
                        } else {
                            alert("잠시 후 다시 시도해 주세요");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCreateChatRoom(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickGround = function(characterId, groundId) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("to?url=/play/characters/".concat(characterId, "/posts/").concat(groundId));
        } else {
            web.openPage("/to?url=/play/characters/".concat(characterId, "/posts/").concat(groundId));
        }
    };
    var handleClickGroundCharacter = function(characterId) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/to?url=/play/characters/".concat(characterId, "?tab=community"));
        } else {
            web.openPage("/to?url=/play/characters/".concat(characterId, "?tab=community"));
        }
    };
    var handleClickChoice = function(idx, situationId) {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/situations/".concat(situationId, "/chat-room?first_message_index=").concat(idx));
        } else {
            web.openPage("/play/situations/".concat(situationId, "/chat-room?first_message_index=").concat(idx));
        }
    };
    var handleNavigateCreate = function() {
        if (platform === constants/* Platform.web */.t4.web) {
            router.push("/play/characters/create");
        } else {
            web.openPage("/play/characters/create");
        }
    };
    (0,react.useEffect)(function() {
        (0,misc/* setFlow */.kB)({
            isDelete: true
        });
        (0,misc/* setFlow */.kB)({
            name: "플레이"
        });
        firebase.logEvent("select_play", {});
        var date = localStorage/* ParsedStorage.getItem */.f.getItem("lastPeekTabViewDate");
        if (date) {
            setLastPeekTabViewDate(date);
        }
    }, []);
    var ref5 = (0,react.useState)(""), remainDate = ref5[0], setRemainDate = ref5[1];
    (0,react.useEffect)(function() {
        var myMessageToken = me === null || me === void 0 ? void 0 : me.chatToken;
        if (window) {
            var promotionWidth = (window === null || window === void 0 ? void 0 : window.innerWidth) - 110;
            setPromoWidth(promotionWidth);
        }
        if (!(myMessageToken === null || myMessageToken === void 0 ? void 0 : myMessageToken.expiredAt)) {
            return;
        }
        var timerId = setInterval(function() {
            var now = new Date();
            var targetDate = new Date(myMessageToken === null || myMessageToken === void 0 ? void 0 : myMessageToken.expiredAt);
            var difference = targetDate.getTime() - now.getTime();
            if (difference <= 0) {
                setRemainDate(null);
                clearInterval(timerId);
                refetchMe();
                return;
            }
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));
            var hours = Math.floor(difference / (1000 * 60 * 60) % 24) + days * 24;
            var minutes = Math.floor(difference / (1000 * 60) % 60);
            var seconds = Math.floor(difference / 1000 % 60);
            var hoursFormatted = hours.toString().padStart(2, "0");
            var minutesFormatted = minutes.toString().padStart(2, "0");
            var secondsFormatted = seconds.toString().padStart(2, "0");
            setRemainDate("".concat(hoursFormatted, ":").concat(minutesFormatted, ":").concat(secondsFormatted));
        }, 1000);
    }, [
        me
    ]);
    // const handleClickPromotion = () => {
    //   if (!isOverVersion) {
    //     const text = '앱을 최신버전으로 업데이트 해주세요!';
    //     return alert(text);
    //   }
    //   if (platform === Platform.web) {
    //     router.push('/payment?tab=subscription');
    //   }
    //   web.openPage('/payment?tab=subscription');
    // };
    // const checkPurchase = async () => {
    //   try {
    //     await fetchSubscriptionDetail(subItemId);
    //     await fetchPassItemDetail(passItemId);
    //   } catch (err) {
    //     setIsAosPurchased(true);
    //   }
    // };
    // useEffect(() => {
    //   if (me) {
    //     checkPurchase();
    //   }
    // }, [me, myMessageToken]);
    (0,react.useEffect)(function() {
        if (shareUUID) {
            postUUID(shareUUID);
        }
    }, [
        shareUUID
    ]);
    var memoizedTabs = (0,react.useMemo)(function() {
        return tabs;
    }, [
        tabs.tabs,
        tabs.activeTab,
        tabs.onChange,
        tabs.lastPeekTabViewDate,
        tabs.setLastPeekTabViewDate, 
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(SafeArea/* default */.Z, {
        bottom: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                fallback: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeHeader/* default */.Z, {
                    hasNewNotification: false,
                    isHome: true
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeHeaderContainer/* PlayHeaderContainer */.K, {
                    tabs: memoizedTabs,
                    lastPeekTabViewDate: lastPeekTabViewDate
                })
            }),
            activeTab === "home" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: homeContainerCSS(isCheming),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Pagination/* PaginationIterator */.gt, {
                    name: "play-outlook-home-list",
                    query: outlook,
                    className: "container",
                    identifier: "key",
                    children: function(item, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(react.Suspense, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(OutlookComponent/* default */.Z, {
                                component: item,
                                order: index,
                                onClickProfile: handleMoveCharacterDetail,
                                onClickSituation: onClickSituation,
                                handleCreateChatRoom: handleCreateChatRoom,
                                onClickSituationById: onClickSituationById,
                                onClickGround: handleClickGround,
                                onClickGroundCharacter: handleClickGroundCharacter,
                                onClickChoice: handleClickChoice
                            }, index)
                        });
                    }
                })
            }),
            activeTab === "home_ground" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_HomeGround, {
                chips: chips
            }),
            activeTab === "home_peek" && isAdult && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(outlook_HomePeek, {
                chips: chips
            }),
            !isCheming && activeTab === "home" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                css: floatingButtonContainerCSS(isCheming),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                    className: "floating-wrapper",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(characters_FloatingCreateButton, {
                            handleOnClick: handleNavigateCreate
                        }),
                        !!(myMessageToken === null || myMessageToken === void 0 ? void 0 : myMessageToken.tokenCount) && promoWidth && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(common_FloatingButton, {
                            left: 16,
                            backgroundColor: theme.colors.blue400,
                            borderRadius: 10,
                            width: promoWidth,
                            height: 62,
                            padding: "12px 10px 12px 14px",
                            className: "floating-promo",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                css: promoCSS,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)("div", {
                                        className: "upper-container",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                                className: "title",
                                                children: t("대화권 ".concat(myMessageToken.tokenCount, "장"))
                                            }),
                                            remainDate && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("div", {
                                                className: "timer",
                                                children: t("".concat(remainDate, " 뒤 소멸 \uD83D\uDEA8"))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("p", {
                                        className: "description",
                                        children: t("모든 대화 모드로 사용할 수 있어요")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var layoutCSS = (0,emotion_react_browser_esm.css)(play_templateObject3(), (0,css/* safeArea */.BI)("top", "padding", 0, 68));
var bannerSkeletonCSS = (0,emotion_react_browser_esm.css)(_templateObject4());
var __N_SSP = true;
var PlayListLoading = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Layout/* default */.Z, {
        isPush: true,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(HomeHeader/* default */.Z, {
                hasNewNotification: false
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Frame/* default */.Z, {
                css: bannerSkeletonCSS
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(SkeletonList/* default */.Z, {
                skeleton: PlaySkeleton/* default */.Z
            })
        ]
    });
};
var Play = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Layout/* default */.Z, {
        css: layoutCSS,
        isPush: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(PlayDetail, {})
    });
};
/* harmony default export */ var play = ((0,auth/* withAuth */.QO)(Play, {
    isSignInRequired: false,
    LoadingComponent: PlayListLoading
}));


/***/ })

}]);